import { PlayCircle, Bell } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { Btn, Eyebrow } from "../components/ui-kit";
import { Reveal } from "../lib/motion";
import { IMAGES } from "../lib/data";

export default function Sermons() {
  return (
    <div data-testid="sermons-page">
      <PageHeader
        eyebrow="Sermons / Media"
        title={"Watch\n& Listen"}
        sub="Our online sermons and media library is getting a fresh new home."
        image={IMAGES.pastor}
      />

      <section className="py-24 sm:py-36 bg-white" data-testid="sermons-coming-soon">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <Reveal>
            <span className="inline-grid place-items-center w-20 h-20 rounded-full bg-[#E63946]/10 text-[#E63946] mb-8">
              <PlayCircle size={38} />
            </span>
            <div className="flex justify-center"><Eyebrow>Coming Soon</Eyebrow></div>
            <h2 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl leading-[1.05] mb-5">
              We're Working on Something Good
            </h2>
            <p className="text-black/60 text-lg leading-relaxed max-w-xl mx-auto mb-10">
              Our sermons &amp; media page is currently under maintenance. Soon you'll be able
              to watch live services and catch up on past messages, worship, and Bible study
              right here. Thank you for your patience &mdash; check back shortly!
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Btn to="/plan-your-visit" testid="sermons-plan-visit"><Bell size={16} /> Plan Your Visit</Btn>
              <Btn to="/" variant="outline" testid="sermons-back-home">Back to Home</Btn>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
